<template>
  <a class="area_al" 
    :class="{ 'active': isActive }">
      <img :src="image" />
      <h1>{{ title }}</h1>
  </a>
</template>

<script>
export default {
  props: ["isActive", "image", "title"],
}
</script>

<style lang="scss" scoped>
.area_al img {
  width: 175px;
}

.area_al {
  width: 250px;
  text-align: center;
  border-bottom: 2px solid #dedee0;
}

.area_al h1 {
  font-family: "Montserrat";
  font-size: 18px;
  padding-top: 35px;
  color: #337e95;
  text-align: center;
  padding-bottom: 15px;
}

.area_al:hover,
.area_al.active {
  border-bottom: 3px solid #337e95;
}

.area_al:hover h1,
.area_al:active h1 {
  font-family: "Montserrat SemiBold";
}

.area_al:hover img,
.area_al.active img {
  width: 180px;
  margin-bottom: -5px;
}

@media (max-width: 767px) {
  .area_al {
    display: none;
  }

  .area_al.active {
    display: block;
  }
}
</style>